module.exports = __webpack_public_path__ + "img/6.aa71d872.jpg";